
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 18c4.924 0 9-4.076 9-9 0-4.915-4.085-9-9.009-9C4.076 0 0 4.085 0 9c0 4.924 4.085 9 9 9zm0-1.5A7.464 7.464 0 011.509 9c0-4.156 3.317-7.5 7.482-7.5A7.49 7.49 0 0116.5 9 7.466 7.466 0 019 16.5zm.732-6.759h2.762c.494 0 .838-.256.838-.723 0-.477-.326-.75-.838-.75H5.497c-.512 0-.847.273-.847.75 0 .467.353.723.847.723h4.235z","fill":"#888","fill-rule":"nonzero"}})])
          )
        }
      }
    